"use client";
import * as React from "react";

export interface CheckboxProps {
  label: string;
  name: string;
  id?: string;
  checked: boolean;
  handleChange: (e: any) => void;
}

import styles from "./index.module.css";

function Checkbox(props: CheckboxProps) {
  function id() {
    return props.id ? props.id : props.label.replace(/ /g, "");
  }

  return (
    <label className={styles.label}>
      <input
        type="checkbox"
        id={id()}
        name={props.name}
        checked={props.checked}
        onChange={(event) => props.handleChange(event)}
        className={styles.checkbox}
      />
      {props.label}
    </label>
  );
}

export default Checkbox;
